import PropTypes from 'prop-types';
import './mobileViewProfile.scss';
import React, { useState } from 'react';

const EmployeeProfile = ({ employee, employeeNameMenu, projectDetails }) => {
  const desiredOrder = [0, 3, 1, 2, 4];
  const [imageError, setImageError] = useState(false);

  const sortedEmployeeNameMenu = employeeNameMenu.sort((itemA, itemB) => {
    return (
      desiredOrder.indexOf(itemA.displayOrder)
      - desiredOrder.indexOf(itemB.displayOrder)
    );
  });

  const handleImageError = () => {
    setImageError(true);
  };

  const getInitial = (name) => (name ? name.charAt(0).toUpperCase() : '');

  return (
    <div className="employee-profile-container-mobile">
      <div className="employee-title">Employee profile</div>
      <div className="employee-details">
        <div className="employee-info">
          <div className="employee-picture">
            {!imageError && employee.photoSignedUrl ? (
              <img
                src={employee.photoSignedUrl}
                alt={employee.fullName}
                className="employee-picture-image"
                onError={handleImageError}
                role="presentation"
              />
            ) : (
              <div className="employee-picture-placeholder">
                {getInitial(employee.fullName)}
              </div>
            )}
          </div>
          <div className="employee-personal-details">
            <div className="employee-name">{employee.fullName}</div>
            <div className="employee-name-details">
              {sortedEmployeeNameMenu.map((item) => (
                <div className={`employee-${item.label}`} key={item.label}>
                  <img src={item.iconMobile} alt={`${item.label} Icon`} />
                  <div className={`employee-${item.label}-text`}>
                    {item.text}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="employee-project-details">
          {projectDetails.map((item) => (
            <div
              className={`employee-${item.label
                .toLowerCase()
                .split(' ')
                .join('-')}`}
              key={item.label}
            >
              <div className="employee-project-details-label">{item.label}</div>
              <div className="employee-project-details-text">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

EmployeeProfile.propTypes = {
  employee: PropTypes.array.isRequired,
  employeeNameMenu: PropTypes.arrayOf(PropTypes.object).isRequired,
  projectDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default EmployeeProfile;
